import React, { useState, useRef } from "react";
import "./style.css";
import Navbar from "../../Components/Navbar";
import phone from "../../assests/ContactUs/phone.png";
import mail from "../../assests/ContactUs/mail.png";
import location from "../../assests/ContactUs/location.png";
import faq from "../../assests/ContactUs/Faq.jpg";
import Footer from "../../Components/Footer";
import emailjs from "@emailjs/browser";

interface FAQItemType {
  question: string;
  answer: string;
}

const faqData: FAQItemType[] = [
  { question: "What areas do you serve?", answer: "We provide services exclusively in Singapore and surrounding areas." },
  { question: "Do you offer free site visits or estimates?", answer: "Yes, we offer free site inspections and quotations within Singapore." },
  { question: "Do you install and service all types of AC systems?", answer: "Yes, we handle installation, repair, and servicing of split, ducted, and packaged AC units." },
  { question: "Can you help with electrical rewiring?", answer: "Yes, we manage complete wiring and rewiring projects, including switchgear and panel installations." },
  { question: "Do you maintain CCTV and security systems?", answer: "Yes, we provide routine maintenance and upgrades for CCTV, automated gates, and access systems." },
  { question: "What kind of demolition services do you offer?", answer: "We provide general demolition, diamond wall cutting, hydro demolition, and more." },
  { question: "Can you handle concrete repair and maintenance?", answer: "Yes, our team specializes in concrete repair, crack injection, and rehabilitation." },
  { question: "Do you offer waterproofing works?", answer: "Absolutely, we provide reliable waterproofing services for various structures." },
  { question: "How quickly can you respond to service requests?", answer: "We aim to respond within 24-48 hours for all inquiries." },
  { question: "Are your services compliant with Singapore regulations?", answer: "Yes, all our work complies with local building and safety standards." },
];

const ContactForm = () => {
  const [contactType, setContactType] = useState("person");
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const formRef = useRef<HTMLFormElement>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formRef.current) return;

    emailjs
      .sendForm(
        "service_pd7mc6m",
        "template_848184m",
        formRef.current,
        "8vlreB95aql7qQ4q4"
      )
      .then(
        (result) => {
          alert("Message sent successfully!");
          formRef.current?.reset();
        },
        (error) => {
          alert("Failed to send message. Please try again.");
          console.error(error);
        }
      );
  };

  return (
    <>
     <div className="top-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#6a5af9"
              fillOpacity="1"
              d="M0,128L26.7,106.7C53.3,85,107,43,160,37.3C213.3,32,267,64,320,69.3C373.3,75,427,53,480,48C533.3,43,587,53,640,96C693.3,139,747,213,800,240C853.3,267,907,245,960,202.7C1013.3,160,1067,96,1120,101.3C1173.3,107,1227,181,1280,197.3C1333.3,213,1387,171,1413,149.3L1440,128L1440,0H0Z"
            ></path>
          </svg>
        </div>
      <div className="contact-container">
       
        <Navbar />


        <div className="contactus-card">
          <div className="form-section">
            <h2>Let's Connect</h2>
            <p>
              To request a quote or want to meet, contact us directly or fill
              out the form and we will get back to you promptly.
            </p>

            <form ref={formRef} onSubmit={sendEmail}>
              <input type="text" name="user_name" placeholder="Your Name" required />
              <input type="email" name="user_email" placeholder="Your Email" required />
              <input type="text" name="user_phone" placeholder="Mobile Number" required />
              <input type="text" name="user_address" placeholder="Address" required />

              <select
                name="contact_type"
                value={contactType}
                onChange={(e) => setContactType(e.target.value)}
                required
              >
                <option value="person">Individual</option>
                <option value="company">Company</option>
              </select>

              {contactType === "company" && (
                <input type="text" name="company_name" placeholder="Company Name" required />
              )}

              <textarea name="message" placeholder="Reason for Contact" required />

              <div
                className="cntct-btn"
                onClick={() => formRef.current?.requestSubmit()}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    formRef.current?.requestSubmit();
                  }
                }}
              >
                Send Message
              </div>

            </form>
          </div>

          <div className="left-side">
            <div className="info-item">
              <img src={phone} alt="Phone" className="icon" />
              <p>+65 91005854</p>
            </div>

            <div className="info-item">
              <img src={mail} alt="Email" className="icon" />
              <p>sales@innovationsolutions.net</p>
            </div>

            <div className="info-item">
              <img src={location} alt="Location" className="icon" />
              <p>Blk 301 Serangoon Ave 2#01-334 Singapore</p>
            </div>
          </div>
        </div>

        <h1 className="faq-title">Frequently Asked Questions</h1>
        <p>
          Find answers to common questions about our services, coverage areas,
          and response times. If you don't see your question here, feel free to
          contact us directly — we're happy to help.
        </p>

        <div
          className="faq-wrapper"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "50px",
            padding: "60px 0",
            width: "80%",
            margin: "0 auto",
          }}
        >
          <div className="faq-image" style={{ flex: 1 }}>
            <img
              src={faq}
              alt="FAQ Illustration"
              style={{ width: "700px", height: "550px" }}
            />
          </div>

          <div className="faq-list" style={{ flex: 2 }}>
            {faqData.map((item, index) => (
              <div key={index} className="faq-item" style={{ marginBottom: "20px" }}>
                <div
                  className={`faq-question ${openIndex === index ? "active" : ""}`}
                  onClick={() => toggleFAQ(index)}
                  style={{
                    cursor: "pointer",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 0",
                    borderBottom: "1px solid #ccc",
                  }}
                >
                  {item.question}
                  <span>{openIndex === index ? "▲" : "▼"}</span>
                </div>
                {openIndex === index && (
                  <div className="faq-answer" style={{ padding: "10px 0 0 10px", color: "#555" }}>
                    {item.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ContactForm;
